import React, { useState } from 'react';
import { Col, Card, CardBody, CardHeader, Container, Row, Table, Input, Button } from 'reactstrap';
import { useGetOperatorsQuery, useCreateOperatorMutation } from '../../features/ordersApiSlice';
import { toast } from 'react-toastify';

const Operators = () => {
  const { data: operatorsData, refetch } = useGetOperatorsQuery();
  const [createOperator, { isLoading: creating }] = useCreateOperatorMutation();

  const [name, setName] = useState('');
  const [password, setPassword] = useState('');

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name || !password) return toast.error('Name and password are required.');
    try {
      const res = await createOperator({ name, password }).unwrap();
      toast.success(`Operator "${res.name}" created.`);
      setName('');
      setPassword('');
      refetch();
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to create operator.');
    }
  };

  const operators = operatorsData?.data || [];

  return (
    <Container fluid>
      <Row>
        <Col md="8">
          <Card>
            <CardHeader className="pb-0">
              <h5>Operators</h5>
              <span className="text-muted">Lab operators for the Production Console (riise-ops).</span>
            </CardHeader>
            <CardBody>
              <Table bordered striped responsive size="sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Created</th>
                  </tr>
                </thead>
                <tbody>
                  {operators.map((op) => (
                    <tr key={op.id}>
                      <td>{op.id}</td>
                      <td>{op.name}</td>
                      <td>{op.active ? <span className="badge bg-success">Active</span> : <span className="badge bg-secondary">Inactive</span>}</td>
                      <td>{new Date(op.created_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                    </tr>
                  ))}
                  {operators.length === 0 && (
                    <tr><td colSpan="4" className="text-center text-muted">No operators yet.</td></tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>

        <Col md="4">
          <Card>
            <CardHeader className="pb-0">
              <h5>Create Operator</h5>
            </CardHeader>
            <CardBody>
              <form onSubmit={handleCreate}>
                <label className="form-label">Name</label>
                <Input
                  type="text"
                  placeholder="e.g. Marco"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="mb-3"
                />
                <label className="form-label">Password</label>
                <Input
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mb-3"
                />
                <Button color="primary" type="submit" disabled={creating} block>
                  {creating ? 'Creating...' : 'Create Operator'}
                </Button>
              </form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Operators;
